// extracted by mini-css-extract-plugin
export default {"container":"LoginResponse_container__x8b8D","centerSpinner":"LoginResponse_centerSpinner__1-aLr"};